module.exports = __webpack_public_path__ + "aca6678e64ab1a743203709abd131830.svg";